import { EventConfig, GameTypes } from "kadow-jetpack-model";

const TITLE_STYLE = {
  fontFamily: "BigJohn, serif",
  fontWeight: "bold",
  fontSize: "45px",
  lineHeight: "1.2",
  color: "red",
  textShadow:
    "3px 3px 0 white, -3px -3px 0 white, -3px 3px 0 white, 3px -3px 0 white",
  transform: "rotate(-10deg)",
  textTransform: "uppercase",
  textAlign: "center",
  width: "80%"
};

const CARD_TITLE_STYLE = {
  fontFamily: "BigJohn, serif",
  fontWeight: "bold",
  fontSize: "20px",
  lineHeight: "1.2",
  width: "80%",
  color: "red",
  textShadow:
    "2px 2px 0 white, -2px -2px 0 white, -2px 2px 0 white, 2px -2px 0 white",
  transform: "rotate(-10deg)",
  textTransform: "uppercase",
  textAlign: "center"
};

const DEFAULT_EVENT: EventConfig = {
  _id: "default",
  name: "Jetpack default event",
  ts: 1,
  skins: [
    // ...PERFORMANCE_GAME_SKINS,
    {
      id: "ggsfb81",
      eventId: "default",
      game: GameTypes.SlotMachine,
      items: [
        {
          id: "84bevem2",
          name: "Background",
          type: "color",
          value: "",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            background:
              "radial-gradient(ellipse at center, #fff 0%, #E35F6D 30%, #BA354C 100%)",
            zIndex: "0"
          }
        },
        {
          id: "84bevem",
          name: "Item 2",
          type: "image",
          value: "9gio8wp.svg",
          style: {
            position: "absolute",
            width: "120%",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "1"
          }
        },
        {
          id: "r1frmdf",
          name: "Item 3",
          type: "image",
          value: "pz0api8.svg",
          style: {
            position: "absolute",
            width: "90%",
            top: "72%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "3"
          }
        },
        {
          id: "hkjfur5",
          name: "Title",
          type: "text",
          content: {
            fr: "JACKPOT",
            en: "JACKPOT"
          },
          style: {
            ...TITLE_STYLE,
            zIndex: "4",
            position: "absolute",
            top: "75px"
          },
          ratios: []
        }
      ],
      gameZ: "2",
      gameConfig: {
        gameStyle: {
          width: "100%",
          display: "grid",
          placeItems: "center"
        },
        cardBackground: "bfww5xf.png",
        image: "w87n9ig.svg"
      },
      gameCardConfig: {
        background: {
          url: "bfww5xf.png"
        },
        title: {
          content: {
            fr: "JACKPOT",
            en: "JACKPOT"
          },
          style: {
            ...CARD_TITLE_STYLE
          }
        },
        description: {
          content: {
            fr: "1 chance de toucher le jackpot",
            en: "1 chance to hit the jackpot"
          },
          style: {
            color: "white"
          }
        }
      }
    },
    {
      id: "ld7nd31",
      eventId: "default",
      game: GameTypes.ScratchCard,
      gameZ: "2",
      items: [
        {
          id: "background",
          name: "Background",
          type: "image",
          value: "qyzhufc.png",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "0"
          }
        },
        {
          id: "foreground",
          name: "Foreground",
          type: "image",
          value: "oxx7xew.svg",
          style: {
            position: "absolute",
            width: "100%",
            top: "0",
            zIndex: "1"
          }
        },
        {
          id: "title",
          name: "Title",
          type: "text",
          content: {
            fr: "GRATTEZ LA CARTE",
            en: "SCRATCH THE CARD"
          },
          style: {
            ...TITLE_STYLE,
            top: "20px",
            width: "75%",
            zIndex: "3",
            position: "absolute"
          }
        }
      ],
      gameConfig: {
        image: "/sc-card.png",
        gameStyle: {
          width: "100%",
          height: "100%"
        }
      },
      gameCardConfig: {
        background: {
          url: "qzqvrd9.png"
        },
        title: {
          content: {
            fr: "Carte à gratter",
            en: "Scratch card"
          },
          style: {
            ...CARD_TITLE_STYLE,
            position: "absolute",
            top: "20px"
          }
        },
        description: {
          content: {
            fr: "Grattez pour découvrir votre cadeau !",
            en: "Scratch to discover your gift !"
          },
          style: {
            color: "white"
          }
        }
      }
    },
    {
      id: "ld7nd32",
      eventId: "default",
      game: GameTypes.FlipCards,
      gameZ: "1",
      items: [
        {
          id: "background",
          name: "Background",
          type: "image",
          value: "zz0v569.png",
          style: {
            position: "absolute",
            width: "101%",
            height: "101%",
            zIndex: "0"
          }
        },
        {
          id: "title",
          name: "Title",
          type: "text",
          content: {
            fr: "CARTES MYSTÈRE",
            en: "MYSTERY CARDS"
          },
          style: {
            ...TITLE_STYLE,
            position: "absolute",
            top: "20px",
            zIndex: "2"
          }
        }
      ],
      gameConfig: {
        gameStyle: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%"
        },
        colorOne: "#EA032F",
        colorTwo: "#EA032F"
      },
      gameCardConfig: {
        background: {
          url: "nkfj7pj.png"
        },
        title: {
          content: {
            fr: "CARTES MYSTÈRE",
            en: "MYSTERY CARDS"
          },
          style: {
            ...CARD_TITLE_STYLE,
            position: "absolute",
            top: "20px"
          }
        },
        description: {
          content: {
            fr: "Retournez la bonne carte !",
            en: "Turn the right card!"
          },
          style: {
            color: "white"
          }
        }
      }
    },
    {
      id: "ld7nd33",
      eventId: "default",
      game: GameTypes.MysteryBoxes,
      gameZ: "2",
      items: [
        {
          id: "background",
          name: "Background",
          type: "image",
          value: "mb-bg.png",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "0"
          }
        },
        {
          id: "foreground",
          name: "Foreground",
          type: "image",
          value: "mb-fg.svg",
          style: {
            position: "absolute",
            width: "100%",
            top: "0",
            zIndex: "1"
          }
        },
        {
          id: "title",
          name: "Title",
          type: "text",
          content: {
            fr: "SURPRISE !",
            en: "SURPRISE !"
          },
          style: {
            ...TITLE_STYLE,
            position: "absolute",
            width: "75%",
            top: "20px",
            zIndex: "3"
          }
        }
      ],
      gameConfig: {
        gameStyle: {
          paddingTop: "20px"
        },
        MYSTERY_BOXES_BODY_INSIDE: "#C2C1C1",
        MYSTERY_BOXES_BODY: "white",
        MYSTERY_BOXES_BODY_BOTTOM: "#f4f9fd",
        MYSTERY_BOXES_RIBBON: "#F91949",
        MYSTERY_BOXES_COVER: "#dcf2fd"
      },
      gameCardConfig: {
        background: {
          url: "6imuiwe.png"
        },
        title: {
          content: {
            fr: "SURPRISE !",
            en: "SURPRISE !"
          },
          style: {
            ...CARD_TITLE_STYLE,
            position: "absolute",
            top: "36%",
            width: "70%"
          }
        },
        description: {
          content: {
            fr: "Dans quelle boîte se cache votre cadeau ?",
            en: "In which box is your gift hidden ?"
          },
          style: {
            color: "white"
          }
        }
      }
    },
    {
      id: "ld7nd34",
      eventId: "default",
      game: GameTypes.Fakir,
      gameZ: "1",
      items: [
        {
          id: "background",
          name: "Background",
          type: "image",
          value: "fk-bg.png",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "0"
          }
        },
        {
          id: "title",
          name: "Title",
          type: "text",
          content: {
            fr: "Jeu du fakir",
            en: "Fakir game"
          },
          style: {
            ...TITLE_STYLE,
            position: "absolute",
            top: "20px",
            width: "75%",
            zIndex: "2"
          }
        }
      ],
      gameConfig: {
        gameStyle: {
          width: "100%",
          top: "140px"
        },
        backgroundColor: "#10151A",
        pinColor: "#f1ce4c",
        lineColor: "white",
        ballColor: "#FFCE00",
        ballAsset: "",
        holeAsset: ""
      },
      gameCardConfig: {
        background: {
          url: "vewnhxe.png"
        },
        title: {
          content: {
            fr: "Jeu du fakir",
            en: "Fakir game"
          },
          style: {
            ...CARD_TITLE_STYLE,
            width: "49%"
          }
        },
        description: {
          content: {
            fr: "Lâchez la balle au bon moment !",
            en: "Drop the ball at the right time !"
          },
          style: {
            color: "white"
          }
        }
      }
    },
    {
      id: "ld7nd35",
      eventId: "default",
      game: GameTypes.FortuneWheel,
      gameZ: "2",
      items: [
        {
          id: "background",
          name: "Background",
          type: "image",
          value: "xmdjidk.png",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "0"
          }
        },
        {
          id: "layer-1",
          name: "Layer 1",
          type: "image",
          value: "mcjhs6k.svg",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-35px",
            zIndex: "1"
          }
        },
        {
          id: "layer-3",
          name: "Layer-3",
          type: "image",
          value: "n5zvpdl.svg",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-16%",
            zIndex: "3"
          }
        },
        {
          id: "title",
          name: "Title",
          type: "text",
          content: {
            fr: "LA ROUE DE LA FORTUNE",
            en: "WHEEL OF FORTUNE"
          },
          style: {
            ...TITLE_STYLE,
            position: "absolute",
            width: "80%",
            top: "20px",
            zIndex: "4",
            fontSize: "30px",
            lineHeight: "36px",
            transform: "unset"
          }
        }
      ],
      gameConfig: {
        gameStyle: {
          width: "100%",
          height: "100%"
        },
        sector1FGColor: "#6365AD",
        sector1BGColor: "white",
        sector2FGColor: "white",
        sector2BGColor: "#6365AD",
        sector3FGColor: "#6365AD",
        sector3BGColor: "white",
        sector4FGColor: "white",
        sector4BGColor: "#6365AD",
        structureFillColor: "white",
        structureTopStrokeColor: "#FCCA59",
        structureFillColor2: "#6272BC",
        structureLinesColor: "#1E3343",
        shadowColor: "#28308E",
        cursorColor: "#FCCA59",
        cursorShadowColor: "#1E3343",
        outlineColor: "black"
      },
      gameCardConfig: {
        background: {
          url: "3y6pd8y.png"
        },
        title: {
          content: {
            fr: "ROUE DE LA CHANCE",
            en: "WHEEL OF FORTUNE"
          },
          style: {
            ...CARD_TITLE_STYLE,
            position: "absolute",
            top: "20px"
          }
        },
        description: {
          content: {
            fr: "Tournez la roue pour découvrir votre cadeau !",
            en: "Spin the wheel to discover your gift !"
          },
          style: {
            color: "white"
          }
        }
      }
    },
    {
      id: "ld7nd36",
      eventId: "default",
      game: GameTypes.Dice,
      gameZ: "2",
      items: [
        {
          id: "background",
          name: "Background",
          type: "image",
          value: "4w1viav.png",
          style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "0"
          }
        },
        {
          id: "foreground",
          name: "Foreground",
          type: "image",
          value: "hsv5zij.svg",
          style: {
            position: "absolute",
            width: "100%",
            top: "0",
            zIndex: "1"
          }
        },
        {
          id: "title",
          name: "Title",
          type: "text",
          content: {
            fr: "DÉS MAGIQUES",
            en: "MAGIC DICE"
          },
          style: {
            ...TITLE_STYLE,
            position: "absolute",
            width: "70%",
            top: "20px",
            zIndex: "3"
          }
        }
      ],
      gameConfig: {
        gameStyle: {},
        diceColor: "#EF0F0F",
        floorColor: "#493A7D",
        gridColor: "#493A7D",
        cardBackground: "woojnkv.png"
      },
      gameCardConfig: {
        background: {
          url: "woojnkv.png"
        },
        title: {
          content: {
            fr: "DÉS MAGIQUES",
            en: "MAGIC DICE"
          },
          style: {
            ...CARD_TITLE_STYLE,
            width: "80%",
            position: "absolute",
            top: "20px"
          }
        },
        description: {
          content: {
            fr: "Un double et c'est gagné !",
            en: "A double and it's won !"
          },
          style: {
            color: "white"
          }
        }
      }
    }
  ],
  assets: [],
  medias: []
};
export default DEFAULT_EVENT;
